import React from "react";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Input,
  Textarea,
} from "@chakra-ui/react";

import { numeroInscricaoPGEA } from "../../../utils/masks";

import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";

export const DesativarModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  handleUpdate,
}) => {
  const schema = Yup.object().shape({});

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      ServicoAcolhimentoService.desativarSA(id, values)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Serviço desativado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            handleUpdate();
            onClose();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "crianca") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,
                    icon: "warning",
                    confirmButtonText: "Voltar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          {"Desativar serviço de acolhimento".toUpperCase()}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          <Formik
            validationSchema={schema}
            initialValues={{
              procedimento: "",
              observacao: "",
            }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(props) => (
              <Form>
                <Flex flexDir="column">
                  <Field name="procedimento">
                    {({ field, form }) => (
                      <Flex flexDir="column">
                        <FormControl
                          isInvalid={
                            form.errors.procedimento &&
                            form.touched.procedimento
                          }
                        >
                          <FormLabel htmlFor="procedimento">
                            Procedimento de desativação
                          </FormLabel>
                          <Input
                            {...field}
                            h="42px"
                            name="procedimento"
                            id="procedimento"
                            backgroundColor="#fff"
                            autoComplete="off"
                            border="1px solid #D7D8DE"
                            placeholder="Informe o número do procedimento"
                            onChange={(e) => {
                              form.setFieldValue(
                                "procedimento",
                                numeroInscricaoPGEA(e.target.value)
                              );
                            }}
                          />
                          <FormErrorMessage>
                            {form.errors.procedimento}
                          </FormErrorMessage>
                        </FormControl>
                      </Flex>
                    )}
                  </Field>

                  <Field name="observacao">
                    {({ field, form }) => (
                      <Flex flexDir="column" mt="20px">
                        <FormControl
                          isInvalid={
                            form.errors.observacao && form.touched.observacao
                          }
                        >
                          <FormLabel htmlFor="observacao">
                            Observações
                          </FormLabel>
                          <Textarea
                            {...field}
                            name="observacao"
                            id="observacao"
                            backgroundColor="#fff"
                            autoComplete="off"
                            border="1px solid #D7D8DE"
                            placeholder="Informe as observações"
                          />
                          <FormErrorMessage>
                            {form.errors.observacao}
                          </FormErrorMessage>
                        </FormControl>
                      </Flex>
                    )}
                  </Field>

                  <Flex flexDir="row-reverse" mt="30px">
                    <Button
                      type="submit"
                      translate="no"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting}
                    >
                      Desativar
                    </Button>
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={onClose}
                      mr="20px"
                    >
                      Cancelar
                    </Button>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
